// extracted by mini-css-extract-plugin
export default {"main":"imperfeitowriter_main__Yil23","title":"imperfeitowriter_title__OFGh+"};